import { useTranslation } from 'react-i18next';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import PropTypes from 'prop-types';

const Faq = ({ homepagedata }) => { 
    const { t } = useTranslation();
    return (            
        <div className="FAQSec" data-aos="fade-up-right" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay="100">
            <div className='container'>
                <div className='FAQDv'>
                    <h3>{t('Frequently Asked Questions')}</h3>
                    <p>{homepagedata?.faq_description}</p>
                    <Accordion transition transitionTimeout={250}>
                        <div className='row'>
                            <div className='col-lg-6'>
                                <AccordionItem header={t("How to Invest in KKOG Token?")} initialEntered>
                                    <div className='FaqCntLd'>
                                        <h4>1. KKOG {t('Token Signup')}</h4>
                                        <p>{t('Visit the Web App and Signup or Login if you already have an account. If you forgot your password just press Forgot Password on the login page and follow the instructions.')}</p>
                                    </div>
                                    <div className='FaqCntLd'>
                                        <h4>2.{t('Get Cryptocurrency')}</h4>
                                        <p>{t('Acquire the required cryptocurrencies of the acceptable payment methods. These include all major cryptocurrencies like Bitcoin, Ethereum, USDT, USDC, PYUSD, BNB and a lot more which you can see on the investment page, which you can use to buy Tesla Token.')}</p>
                                    </div>
                                    <div className='FaqCntLd'>
                                        <h4>3. {t('Buy KKOG Token')}</h4>
                                        <p>{t('Now you Enter the amount of KKOG you need accordingly')} &gt; {t('Select the cryptocurrency you possess')} &gt; {t('Make the payment and get the expected amount of  KKOG Token.')}</p>
                                    </div>
                                </AccordionItem>
                                <AccordionItem header={t("What is the goal of the presale?")}>
                                    <div className='FaqCntLd'>
                                        <p>{t('KKOG Token is decentralized cryptocurrency, no one controls it but you as an investor, backed by some of the most successful companies in the field..')}</p>
                                    </div>                                    
                                </AccordionItem>                        
                            </div>
                            <div className='col-lg-6'>
                                <AccordionItem header={t("What is the goal of the presale?")}>
                                    <div className='FaqCntLd'>
                                        <p>{t('KKOG Token is decentralized cryptocurrency, no one controls it but you as an investor, backed by some of the most successful companies in the field..')}</p>
                                    </div>
                                </AccordionItem>
                                <AccordionItem header={t("How many tokens can I buy ?")}>
                                    <div className='FaqCntLd'>
                                        <p>{t('KKOG Token is decentralized cryptocurrency, no one controls it but you as an investor, backed by some of the most successful companies in the field..')}</p>
                                    </div>
                                </AccordionItem>
                            </div>
                        </div>                        
                    </Accordion>
                </div>
            </div>
        </div>
    );
   
}

Faq.propTypes = {
    homepagedata: PropTypes.shape({
        faq_description : PropTypes.any,
    }),
}


export default Faq;